/**
 * @generated SignedSource<<e356ddeac6632deae372d6b1aacb0410>>
 * @relayHash 80f68a48c59a7cd13650d7615d194381
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 1a3e61cb5577745aad35e2c726174ab6384157800a1b9af9c37be6c966c0eb14

import type { PreloadableConcreteRequest } from 'relay-runtime';
import type { decomposedSummaryQuery } from './decomposedSummaryQuery.graphql';

const node: PreloadableConcreteRequest<decomposedSummaryQuery> = {
  "kind": "PreloadableConcreteRequest",
  "params": {
    "id": "1a3e61cb5577745aad35e2c726174ab6384157800a1b9af9c37be6c966c0eb14",
    "metadata": {},
    "name": "decomposedSummaryQuery",
    "operationKind": "query",
    "text": null
  }
};

export default node;
